import {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import constant from '../../constant';
import {setSessionStorage} from '../../utils';
import {v1_modules} from '../../actions/v1/module';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import {v2_dashboard_header_count} from '../../actions/v2/dashboard';

const Sidebar = (props) => {
    const [modules, setModules] = useState([]);
    const [openSections, setOpenSections] = useState({});
    const [openSubMenus, setOpenSubMenus] = useState({});

    const [count, setCount] = useState({

        productionForms: '',
        siteManagementForms: '',
        project: '',
        leaveRequest: '',
        expenseApproval: '',
        ship: '',
        yard: '',
        shipOwner: ''

    })

    useEffect(() => {
        v2_dashboard_header_count().then((res) => {
            if (res.status) {

                setCount(res.result)
            }
        })
    }, [])

    useEffect(() => {
        const fetchedModules = JSON.parse(sessionStorage.getItem(constant.keys.userModule));
        if (!fetchedModules) {
            v1_modules().then((res) => {
                if (res.status) {
                    setSessionStorage(constant.keys.userModule, res.result)
                    setModules(JSON.parse(atob(res.result)));

                }
            })
        } else {
            setModules(JSON.parse(atob(fetchedModules)));
        }
    }, [])

    const menuItems = [

        {
            moduleId: 0,
            title: 'Dashboard',
            key: 'application-statistics',
            isTitleLink: true,
            icon: 'bx bxs-ship',
            titleUrl: constant.Authedcomponent.dashboard.url,
            width: '150%',
            items: [
                {
                    key: 'production',
                    icon: 'bx bxs-notepad',
                    text: 'Production',
                    url: constant.Authedcomponent.production.url,
                    count: String(count.productionForms)
                },
                {
                    key: 'siteManagement',
                    icon: 'bx bxs-badge-check',
                    text: 'Site Management',
                    url: constant.Authedcomponent.siteManagement.url,
                    count: String(count.siteManagementForms)

                }, {
                    key: 'projects',
                    icon: 'fa fa-ship',
                    text: 'Projects',
                    url: constant.Authedcomponent.listProject.url,
                    count: String(count.project)
                }, {
                    key: 'leaveRequest',
                    icon: 'bx bxs-badge-check',
                    text: 'Leave Request',
                    url: constant.Authedcomponent.leaveApplications.url,
                    count: String(count.leaveRequest)
                },
                {
                    key: 'expenseApproval',
                    icon: 'fa fa-check-square',
                    text: 'Expense Approval',
                    url: constant.Authedcomponent.expenseApplications.url,
                    count: String(count.expenseApproval)
                }, {
                    key: 'totalShips',
                    icon: 'fa fa-ship',
                    text: 'Total Ships',
                    url: constant.Authedcomponent.listShipMasterData.url,
                    count: String(count.ship)
                },
                {
                    key: 'totalYards',
                    icon: 'fa fa-ship',
                    text: 'Total Yards',
                    url: constant.Authedcomponent.listYardMasterData.url,
                    count: String(count.yard)
                }, {
                    key: 'shipOwner',
                    icon: 'fa fa-users',
                    text: 'Ship Owner',
                    url: constant.Authedcomponent.listShipOwnerMasterData.url,
                    count: String(count.shipOwner)
                },

            ],
            activeUrls: [
                constant.Authedcomponent.dashboard.url
            ]
        },
        {
            moduleId: 23,
            title: 'Schedule',
            key: 'schedule',
            isTitleLink: true,
            icon: 'bx bxs-calendar-event',
            titleUrl: constant.Authedcomponent.schedulePreview.url,
            activeUrls: [
                constant.Authedcomponent.schedulePreview.url,
                constant.Authedcomponent.addEventSchdule.url

            ]
        },
        {
            moduleId: 24,
            title: 'Document',
            key: 'documents',
            isTitleLink: true,
            icon: 'bx bxs-file-doc', // 📄 Document icon
            titleUrl: constant.Authedcomponent.projectDocumentCount.url,
            activeUrls: [
                constant.Authedcomponent.projectDocumentCount.url,
                constant.Authedcomponent.addDocument.url,
                constant.Authedcomponent.shipDocument.url,
            ]
        },

        {
            moduleId: 25,
            title: 'Plan Approval',
            key: 'plan-approval', // fixed spelling: 'approval'
            isTitleLink: true,
            icon: 'bx bxs-check-shield', // ✅ Shield with check (for approval)
            titleUrl: constant.Authedcomponent.planApprovalIndex.url,
            activeUrls: [
                constant.Authedcomponent.planApprovalIndex.url,
                constant.Authedcomponent.planApprovalCreate.url,
                constant.Authedcomponent.planApprovalDetail.url,
                constant.Authedcomponent.planApprovalProject.url,
            ]
        },
        {
            moduleId: 26,
            title: 'Inspection',
            key: 'inspection',
            isTitleLink: true,
            icon: 'bx bxs-search-alt-2', // 🔍 Inspection (search)
            titleUrl: constant.Authedcomponent.inspectionIndex.url,
            activeUrls: [
                constant.Authedcomponent.inspectionIndex.url,
                constant.Authedcomponent.inspectionCreate.url,
                constant.Authedcomponent.inspectionProject.url,

            ]
        },
        {
            moduleId: 27,
            title: 'NCR',
            key: 'ncr',
            isTitleLink: true,
            icon: 'bx bxs-error', // ❗ Error icon (for NCR - non-conformance report)
            titleUrl: constant.Authedcomponent.ncrIndex.url,
            activeUrls: [
                constant.Authedcomponent.ncrIndex.url,
                constant.Authedcomponent.ncrCreateComment.url,
                constant.Authedcomponent.ncrDetail.url,
                constant.Authedcomponent.ncrList.url,
                constant.Authedcomponent.ncrCreate.url,


            ]
        },
        {
            moduleId: 28,
            title: 'FAT',
            key: 'fat',
            isTitleLink: true,
            icon: 'bx bxs-analyse', // 📊 Analyse icon (for FAT - factory acceptance test)
            titleUrl: constant.Authedcomponent.fatIndex.url,
            activeUrls: [
                constant.Authedcomponent.fatIndex.url,
                constant.Authedcomponent.fatCreate.url,
                constant.Authedcomponent.fatDetail.url,
                constant.Authedcomponent.fatProject.url,


            ]
        },
        {
            moduleId: 29,
            title: 'Final Drawing',
            key: 'finalDrawing',
            isTitleLink: true,
            icon: 'bx bx-layer',
            titleUrl: constant.Authedcomponent.finalDrawingIndex.url,
            activeUrls: [
                constant.Authedcomponent.finalDrawingIndex.url,
            ]
        },
        {
            moduleId: 30,
            title: 'Forms',
            key: 'forms',
            isTitleLink: false,
            icon: 'bx bxs-notepad', // 📝 Notepad icon (for forms)
            titleUrl: 'javascript:void(0);',
            items: [

                {
                    key: 'production-create',
                    icon: 'bx bx-task',
                    text: 'Production',
                    url: constant.Authedcomponent.productionReports.url,


                },
                {

                    key: 'site_management',
                    icon: 'fa fa-users',
                    text: 'Site Management',
                    url: constant.Authedcomponent.siteManagement.url,
                },
            ],
            activeUrls: [
                constant.Authedcomponent.productionReports.url,
                constant.Authedcomponent.siteManagement.url
            ]

        },
        {
            moduleId: 22,
            title: 'Master',
            key: 'master-data-management',
            icon: 'bx bxs-collection',
            isTitleLink: false,
            titleUrl: 'javascript:void(0);',
            activeUrls: [
                constant.Authedcomponent.addProject.url,
                constant.Authedcomponent.listProject.url,
                constant.Authedcomponent.createShipOwnerMasterData.url,
                constant.Authedcomponent.listShipOwnerMasterData.url,
                constant.Authedcomponent.createBuilderMasterData.url,
                constant.Authedcomponent.listBuilderMasterData.url,
                constant.Authedcomponent.createShipMasterData.url,
                constant.Authedcomponent.listShipMasterData.url,
                constant.Authedcomponent.createYardMasterData.url,
                constant.Authedcomponent.listYardMasterData.url,
                constant.Authedcomponent.createShipYardMasterData.url,
                constant.Authedcomponent.listShipYardMasterData.url,
                constant.Authedcomponent.createCompanyMasterData.url,
                constant.Authedcomponent.listCompanyMasterData.url,
                constant.Authedcomponent.createShipTypeMasterData.url,
                constant.Authedcomponent.listShipTypeMasterData.url,
                constant.Authedcomponent.createSubContractorMasterData.url,
                constant.Authedcomponent.listSubContractorMasterData.url,
                constant.Authedcomponent.createSiteLocationMasterData.url,
                constant.Authedcomponent.listSiteLocationMasterData.url,
                constant.Authedcomponent.createProjectLocationMasterData.url,
                constant.Authedcomponent.listProjectLocationMasterData.url,
                constant.Authedcomponent.createChannelMasterData.url,
                constant.Authedcomponent.listChannelMasterData.url,
                constant.Authedcomponent.createScheduleCategoryMasterData.url,
                constant.Authedcomponent.listScheduleCategoryMasterData.url,
                constant.Authedcomponent.createCategoryMasterData.url,
                constant.Authedcomponent.listCategoryMasterData.url,
                constant.Authedcomponent.createCategoryEventMasterData.url,
                constant.Authedcomponent.listCategoryEventMasterData.url,
                constant.Authedcomponent.createPlanTypeMasterData.url,
                constant.Authedcomponent.listPlanTypeMasterData.url,
                constant.Authedcomponent.createRemarkOptionMasterData.url,
                constant.Authedcomponent.listRemarkOptionMasterData.url,
                constant.Authedcomponent.createDocumentTypeMasterData.url,
                constant.Authedcomponent.listDocumentTypeMasterData.url,
                constant.Authedcomponent.createLeaveTypeMasterData.url,
                constant.Authedcomponent.listLeaveTypeMasterData.url,
                constant.Authedcomponent.createExpenseTypeMasterData.url,
                constant.Authedcomponent.listExpenseTypeMasterData.url,
                constant.Authedcomponent.createStateMasterData.url,
                constant.Authedcomponent.listStateMasterData.url,
                constant.Authedcomponent.createDistrictMasterData.url,
                constant.Authedcomponent.listDistrictMasterData.url
            ],
            items: [
                {
                    key: 'projects',
                    icon: 'bx bx-task',
                    text: 'Projects',
                    subItems: [
                        {text: 'Create Project', url: constant.Authedcomponent.addProject.url, isLink: true},
                        {text: 'Project List', url: constant.Authedcomponent.listProject.url, isLink: true},
                    ]
                },
                {
                    key: 'shipOwner',
                    icon: 'bx bx-task',
                    text: 'Vessel Owner',
                    subItems: [
                        {
                            text: 'Add Vessel Owner',
                            url: constant.Authedcomponent.createShipOwnerMasterData.url,
                            isLink: true
                        },
                        {
                            text: 'Vessel Owner List',
                            url: constant.Authedcomponent.listShipOwnerMasterData.url,
                            isLink: true
                        }
                    ]
                },

                {
                    key: 'shipBuilder',
                    icon: 'bx bx-task',
                    text: 'Builder',
                    subItems: [
                        {text: 'Add Builder', url: constant.Authedcomponent.createBuilderMasterData.url, isLink: true},
                        {text: 'Builder List', url: constant.Authedcomponent.listBuilderMasterData.url, isLink: true}
                    ]
                },
                {
                    key: 'ship',
                    icon: 'bx bx-task',
                    text: 'Vessels / Hulls',
                    subItems: [
                        {text: 'Add Vessel', url: constant.Authedcomponent.createShipMasterData.url, isLink: true},
                        {text: 'Vessel List', url: constant.Authedcomponent.listShipMasterData.url, isLink: true}
                    ]
                },
                // {
                //   key: 'yard',
                //   icon: 'bx bx-task',
                //   text: 'Yard',
                //   subItems: [
                //     { text: 'Add Yard', url: constant.Authedcomponent.createYardMasterData.url, isLink: true },
                //     { text: 'Yard List', url: constant.Authedcomponent.listYardMasterData.url, isLink: true }
                //   ]
                // },
                {
                    key: 'shipyard',
                    icon: 'bx bx-task',
                    text: 'Shipyard',
                    subItems: [
                        {
                            text: 'Add Shipyard',
                            url: constant.Authedcomponent.createShipYardMasterData.url,
                            isLink: true
                        },
                        {text: 'Shipyard List', url: constant.Authedcomponent.listShipYardMasterData.url, isLink: true}
                    ]
                },

                {
                    key: 'company',
                    icon: 'bx bx-task',
                    text: 'Company',
                    subItems: [
                        {text: 'Add Company', url: constant.Authedcomponent.createCompanyMasterData.url, isLink: true},
                        {text: 'Company List', url: constant.Authedcomponent.listCompanyMasterData.url, isLink: true}
                    ]
                },

                {
                    key: 'shipType',
                    icon: 'bx bx-task',
                    text: 'Ship Type',
                    subItems: [
                        {
                            text: 'Add Ship Type',
                            url: constant.Authedcomponent.createShipTypeMasterData.url,
                            isLink: true
                        },
                        {text: 'Ship Type List', url: constant.Authedcomponent.listShipTypeMasterData.url, isLink: true}
                    ]
                },

                {
                    key: 'subContractor',
                    icon: 'bx bx-task',
                    text: 'Sub Contractor',
                    subItems: [
                        {
                            text: 'Add Sub Contractor',
                            url: constant.Authedcomponent.createSubContractorMasterData.url,
                            isLink: true
                        },
                        {
                            text: 'Sub Contractor List',
                            url: constant.Authedcomponent.listSubContractorMasterData.url,
                            isLink: true
                        }
                    ]
                },
                {
                    key: 'siteLocation',
                    icon: 'bx bx-task',
                    text: 'Site Location',
                    subItems: [
                        {
                            text: 'Add Site Location',
                            url: constant.Authedcomponent.createSiteLocationMasterData.url,
                            isLink: true
                        },
                        {
                            text: 'Site Location List',
                            url: constant.Authedcomponent.listSiteLocationMasterData.url,
                            isLink: true
                        }
                    ]
                },
                {
                    key: 'projectLocation',
                    icon: 'bx bx-task',
                    text: 'Project Location',
                    subItems: [
                        {
                            text: 'Add Project Location',
                            url: constant.Authedcomponent.createProjectLocationMasterData.url,
                            isLink: true
                        },
                        {
                            text: 'Project Location List',
                            url: constant.Authedcomponent.listProjectLocationMasterData.url,
                            isLink: true
                        }
                    ]
                },
                {
                    key: 'channel',
                    icon: 'bx bx-task',
                    text: 'Channel',
                    subItems: [
                        {
                            text: 'Create Channel',
                            url: constant.Authedcomponent.createChannelMasterData.url,
                            isLink: true
                        },
                        {text: 'Channel List', url: constant.Authedcomponent.listChannelMasterData.url, isLink: true},
                    ]
                },
                {
                    key: 'categories',
                    icon: 'bx bx-task',
                    text: 'Schedule Category',
                    subItems: [
                        {
                            text: 'Create Category',
                            url: constant.Authedcomponent.createScheduleCategoryMasterData.url,
                            isLink: true
                        },
                        {
                            text: 'Category List',
                            url: constant.Authedcomponent.listScheduleCategoryMasterData.url,
                            isLink: true
                        },
                    ]
                },
                {
                    key: 'categories',
                    icon: 'bx bx-task',
                    text: 'Category',
                    subItems: [
                        {
                            text: 'Create Category',
                            url: constant.Authedcomponent.createCategoryMasterData.url,
                            isLink: true
                        },
                        {text: 'Category List', url: constant.Authedcomponent.listCategoryMasterData.url, isLink: true},
                    ]
                },
                {
                    key: 'events',
                    icon: 'bx bx-task',
                    text: 'Event Type',
                    subItems: [
                        {
                            text: 'Create Event Type',
                            url: constant.Authedcomponent.createCategoryEventMasterData.url,
                            isLink: true
                        },
                        {
                            text: 'Event Type List',
                            url: constant.Authedcomponent.listCategoryEventMasterData.url,
                            isLink: true
                        },
                    ]
                },
                {
                    key: 'events',
                    icon: 'bx bx-task',
                    text: 'Plan Type',
                    subItems: [
                        {
                            text: 'Create Plan Type',
                            url: constant.Authedcomponent.createPlanTypeMasterData.url,
                            isLink: true
                        },
                        {
                            text: 'Plan Type List',
                            url: constant.Authedcomponent.listPlanTypeMasterData.url,
                            isLink: true
                        },
                    ]
                },
                {
                    key: 'remarkOptions',
                    icon: 'bx bx-task',
                    text: 'Remark Options',
                    subItems: [
                        {
                            text: 'Create Remark Option',
                            url: constant.Authedcomponent.createRemarkOptionMasterData.url,
                            isLink: true
                        },
                        {
                            text: 'Remark Option List',
                            url: constant.Authedcomponent.listRemarkOptionMasterData.url,
                            isLink: true
                        },
                    ]
                },
                {
                    key: 'documents',
                    icon: 'bx bx-task',
                    text: 'Document Type',
                    subItems: [
                        {
                            text: 'Create Document Type',
                            url: constant.Authedcomponent.createDocumentTypeMasterData.url,
                            isLink: true
                        },
                        {
                            text: 'Document Type List',
                            url: constant.Authedcomponent.listDocumentTypeMasterData.url,
                            isLink: true
                        },
                    ]
                },
                {
                    key: 'leaveType',
                    icon: 'bx bx-task',
                    text: 'Leave Type',
                    subItems: [
                        {
                            text: 'Add Leave Type',
                            url: constant.Authedcomponent.createLeaveTypeMasterData.url,
                            isLink: true
                        },
                        {
                            text: 'Leave Type List',
                            url: constant.Authedcomponent.listLeaveTypeMasterData.url,
                            isLink: true
                        }
                    ]
                },
                {
                    key: 'expenseType',
                    icon: 'bx bx-task',
                    text: 'Expense Type',
                    subItems: [
                        {
                            text: 'Add Expense Type',
                            url: constant.Authedcomponent.createExpenseTypeMasterData.url,
                            isLink: true
                        },
                        {
                            text: 'Expense Type List',
                            url: constant.Authedcomponent.listExpenseTypeMasterData.url,
                            isLink: true
                        }
                    ]
                },
                {
                    key: 'state',
                    icon: 'bx bx-task',
                    text: 'State',
                    subItems: [
                        {text: 'Create State', url: constant.Authedcomponent.createStateMasterData.url, isLink: true},
                        {text: 'State List', url: constant.Authedcomponent.listStateMasterData.url, isLink: true}
                    ]
                },
                {
                    key: 'district',
                    icon: 'bx bx-task',
                    text: 'City',
                    subItems: [
                        {text: 'Create City', url: constant.Authedcomponent.createDistrictMasterData.url, isLink: true},
                        {text: 'City List', url: constant.Authedcomponent.listDistrictMasterData.url, isLink: true}
                    ]
                },
            ],

        },
        {
            moduleId: 31,
            title: 'Guaranty Claims',
            key: 'claims',
            isTitleLink: true,
            icon: 'bx bxs-shield', // 📄 Document icon
            titleUrl: constant.Authedcomponent.projectGuarantyClaimCount.url,
            activeUrls: [
                constant.Authedcomponent.projectGuarantyClaimCount.url,
                constant.Authedcomponent.shipGuarantyClaims.url,
                constant.Authedcomponent.createNewGuarantyClaim.url,
            ]
        },
        {
            moduleId: 1,
            title: 'Administration',
            key: 'administration',
            icon: 'bx bxs-cog',
            isTitleLink: false,
            titleUrl: 'javascript:void(0);',
            activeUrls: [
                constant.Authedcomponent.attendanceProjectList.url,
                constant.Authedcomponent.attendanceCreate.url,
                constant.Authedcomponent.attendanceEdit.url,
                constant.Authedcomponent.attendanceMonthlyReport.url,

                constant.Authedcomponent.leaveApply.url,
                constant.Authedcomponent.leaveApplied.url,
                constant.Authedcomponent.leaveApplications.url,
                constant.Authedcomponent.submitNewExpense.url,
                constant.Authedcomponent.expenseList.url,
                constant.Authedcomponent.expenseApplications.url,
                constant.Authedcomponent.submitAppraisalForm.url,
                constant.Authedcomponent.submittedAppraisals.url,
                constant.Authedcomponent.addUser.url,
                constant.Authedcomponent.listUser.url,
                constant.Authedcomponent.addRole.url,
                constant.Authedcomponent.listRole.url,
                constant.Authedcomponent.addDesignation.url,
                constant.Authedcomponent.listDesignation.url,
                constant.Authedcomponent.listModules.url,
                constant.Authedcomponent.assignModules.url,
                constant.Authedcomponent.activityLog.url,
                constant.Authedcomponent.updateGlobalSetting.url
            ],
            items: [
                {
                    key: 'attendace',
                    icon: 'bx bx-task',
                    text: 'Attendance',
                    subItems: [
                        {text: 'My Attendance', url: constant.Authedcomponent.myAttendance.url, isLink: true},
                        {
                            text: 'Manage Attendance',
                            url: constant.Authedcomponent.attendanceProjectList.url,
                            isLink: true
                        },
                    ]
                },
                {
                    key: 'leaves',
                    icon: 'bx bx-task',
                    text: 'Leaves',
                    subItems: [
                        {text: 'Apply for Leave', url: constant.Authedcomponent.leaveApply.url, isLink: true},
                        {text: 'My Leave Request', url: constant.Authedcomponent.leaveApplied.url, isLink: true},
                        {text: 'Leave Applications', url: constant.Authedcomponent.leaveApplications.url, isLink: true},

                    ]
                },
                {
                    key: 'expenses',
                    icon: 'bx bx-task',
                    text: 'Expenses',
                    subItems: [
                        {text: 'Submit Expense', url: constant.Authedcomponent.submitNewExpense.url, isLink: true},
                        {text: 'My Expense Request', url: constant.Authedcomponent.expenseList.url, isLink: true},
                        {
                            text: 'Expenses Approvals',
                            url: constant.Authedcomponent.expenseApplications.url,
                            isLink: true
                        },

                    ]
                },
                {
                    key: 'appraisal',
                    icon: 'bx bx-task',
                    text: 'Appraisal',
                    subItems: [
                        {text: 'Create Report', url: constant.Authedcomponent.submitAppraisalForm.url, isLink: true},
                        {text: 'Report List', url: constant.Authedcomponent.submittedAppraisals.url, isLink: true},

                    ]
                },
                {
                    key: 'admin',
                    icon: 'bx bxs-user',
                    text: 'Application User',
                    subItems: [
                        {text: 'Add User', url: constant.Authedcomponent.addUser.url, isLink: true},
                        {text: 'User List', url: constant.Authedcomponent.listUser.url, isLink: true},
                    ]
                },
                {
                    key: 'admin',
                    icon: 'bx bxs-user',
                    text: 'Roles',
                    subItems: [
                        {text: 'Add Roles', url: constant.Authedcomponent.addRole.url, isLink: true},
                        {text: 'Roles List', url: constant.Authedcomponent.listRole.url, isLink: true},
                    ]
                },
                {
                    key: 'admin',
                    icon: 'bx bxs-user',
                    text: 'Designations',
                    subItems: [
                        {text: 'Add Designations', url: constant.Authedcomponent.addDesignation.url, isLink: true},
                        {text: 'Designations List', url: constant.Authedcomponent.listDesignation.url, isLink: true},
                    ]
                },
                {
                    key: 'admin',
                    icon: 'bx bxs-user',
                    text: 'Modules',
                    url: constant.Authedcomponent.assignModules.url,
                },
                {
                    key: 'admin',
                    icon: 'bx bxs-user',
                    text: 'Activity Log',
                    url: constant.Authedcomponent.activityLog.url,
                },
                {
                    key: 'global-setting',
                    icon: 'bx bxs-user',
                    text: 'Global Setting',
                    url: constant.Authedcomponent.updateGlobalSetting.url,
                },

            ]
        },
    ];

    useEffect(() => {

        const fetchedModules = JSON.parse(sessionStorage.getItem(constant.keys.userModule));
        if (!fetchedModules) {
            v1_modules().then((res) => {
                if (res.status) {
                    setSessionStorage(constant.keys.userModule, res.result)
                    setModules(JSON.parse(atob(res.result)));

                }
            })
        } else {
            setModules(JSON.parse(atob(fetchedModules)));
        }

    }, [])

    const checkIsActiveSection = (section, currentPath) => {
        // ✅ Use activeUrls array if present
        if (Array.isArray(section.activeUrls) && section.activeUrls.some(url => currentPath === url)) {
            return true;
        }

        return false;
    };

    const toggleSection = (sectionKey) => {
        setOpenSections(prev => ({
            ...prev,
            [sectionKey]: !prev[sectionKey]
        }));
    };

    const showSection = (sectionKey) => {
        setOpenSections(prev => ({
            ...prev,
            [sectionKey]: true
        }));
    };

    const hideSection = (sectionKey) => {
        setOpenSections(prev => ({
            ...prev,
            [sectionKey]: false
        }));
    };

    const toggleSubMenu = (subMenuKey) => {
        setOpenSubMenus(prev => ({
            ...prev,
            [subMenuKey]: !prev[subMenuKey]
        }));
    };

    const showSubMenu = (subMenuKey) => {
        setOpenSubMenus(prev => ({
            ...prev,
            [subMenuKey]: true
        }));
    };

    const hideSubMenu = (subMenuKey) => {
        setOpenSubMenus(prev => ({
            ...prev,
            [subMenuKey]: false
        }));
    };


    return (
        <>
            <div className="topnav">
                <div className="container-fluid">
                    <nav className="navbar navbar-light navbar-expand-lg topnav-menu">
                        <div className="collapse navbar-collapse active" id="topnav-menu-content">
                            <ul className="navbar-nav active">
                                {menuItems
                                    .filter(section =>
                                        modules.some(mod => mod.MODULE_ID === section.moduleId) || section.moduleId === 0
                                    )
                                    .map((section, sectionIndex, visibleSections) => {
                                        const isLast = sectionIndex === visibleSections.length - 1;
                                        const isActive = checkIsActiveSection(section, props.location.pathname);
                                        const isSectionOpen = !!openSections[section.key];

                                        return (
                                            <li className={`nav-item dropdown ${isActive ? 'mm-active' : ''} ${isSectionOpen ? 'show' : ''}`}
                                                key={sectionIndex}
                                                onMouseEnter={() => {
                                                    if (section.items?.length > 0) {
                                                        showSection(section.key);
                                                    }
                                                }}
                                                onMouseLeave={() => {
                                                    if (section.items?.length > 0) {
                                                        hideSection(section.key);
                                                    }
                                                }}>


                                                {/*<a*/}
                                                {/*  className="nav-link dropdown-toggle arrow-none"*/}
                                                {/*  href={section.isTitleLink ? section.titleUrl : 'javascript:void(0);'}*/}
                                                {/*  id={`topnav-${section.key}`}*/}
                                                {/*  role="button"*/}
                                                {/*>*/}
                                                {/*  {section.icon && <i className={`${section.icon} me-2`} />}*/}
                                                {/*  <span>{section.title}</span>*/}
                                                {/*  {section.items?.length > 0 && <div className="arrow-down"></div>}*/}
                                                {/*</a>*/}

                                                <a
                                                    className="nav-link dropdown-toggle arrow-none"
                                                    href="#"
                                                    id={`topnav-${section.key}`}
                                                    role="button"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        if (section.isTitleLink && section.titleUrl) {
                                                            props.history.push(section.titleUrl); // SPA navigation
                                                            return;
                                                        }

                                                        if (section.items?.length > 0) {
                                                            toggleSection(section.key);
                                                        }
                                                    }}
                                                    aria-expanded={isSectionOpen}
                                                >
                                                    {section.icon && <i className={`${section.icon} me-2`}/>}
                                                    <span>{section.title}</span>
                                                    {section.items?.length > 0 && <div className="arrow-down"></div>}
                                                </a>

                                                {section.items?.length > 0 && (
                                                    <div
                                                        className={`dropdown-menu ${isSectionOpen ? 'show' : ''} ${isLast ? 'dropdown-menu-end' : ''}`}
                                                        style={section.width ? {width: section.width} : {}}
                                                        aria-labelledby={`topnav-${section.key}`}
                                                    >
                                                        {section.items.map((menu, menuIndex) => {
                                                            const subMenuKey = `${section.key}-${menu.key}-${menuIndex}`;
                                                            const isSubMenuOpen = !!openSubMenus[subMenuKey];

                                                            return (
                                                                menu.subItems ? (
                                                                    <div className={`dropdown ${isSubMenuOpen ? 'show' : ''}`}
                                                                         key={menuIndex}
                                                                         onMouseEnter={() => showSubMenu(subMenuKey)}
                                                                         onMouseLeave={() => hideSubMenu(subMenuKey)}>
                                                                        <a className="dropdown-item dropdown-toggle arrow-none"
                                                                           href="javascript:void(0);"
                                                                           role="button"
                                                                           onClick={(e) => {
                                                                               e.preventDefault();
                                                                               e.stopPropagation();
                                                                               toggleSubMenu(subMenuKey);
                                                                           }}
                                                                           aria-expanded={isSubMenuOpen}>
                                                                            {menu.text}
                                                                            <div className="arrow-down"></div>
                                                                        </a>
                                                                        <div className={`dropdown-menu ${isSubMenuOpen ? 'show' : ''}`}
                                                                             style={isLast ? {
                                                                                 width: '100%',
                                                                                 left: 'auto',
                                                                                 right: '100%'
                                                                             } : {
                                                                                 width: '100%'
                                                                             }}>
                                                                            {menu.subItems.map((subItem, subIndex) => (
                                                                                <Link
                                                                                    to={subItem.url}
                                                                                    className={`dropdown-item ${props.location.pathname.startsWith(subItem.url) ? 'active' : ''}`}
                                                                                    key={subIndex}
                                                                                >
                                                                                    {subItem.text}
                                                                                </Link>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <Link
                                                                        to={menu.url}
                                                                        className={`dropdown-item ${props.location.pathname.startsWith(menu.url) ? 'active' : ''}`}
                                                                        key={menuIndex}
                                                                    >
                                                                        {menu.text}
                                                                        {menu.count && (
                                                                            <span
                                                                                className="badge rounded-pill float-end"
                                                                                style={{
                                                                                    backgroundColor: '#2b5a7e',
                                                                                    color: '#fff'
                                                                                }}
                                                                            >
                                      {menu.count}
                                    </span>
                                                                        )}
                                                                    </Link>
                                                                )
                                                            )
                                                        })}
                                                    </div>
                                                )}
                                            </li>
                                        );
                                    })}
                            </ul>
                        </div>
                    </nav>
                </div>
            </div>

        </>
    );
};

export default withRouter(Sidebar);
